// 统一引入api模块
import Task from './apiUrl/task/task'
import subsonic from './apiUrl/subsonic'
export default {
    Task, subsonic
}
